import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { GuestHomePage } from './GuestHomePage';
import { normalizeNextPath } from '../utils/onboardingNavigation';
import { buildProspectorEntryPath } from '../utils/landingSourceKey';

export const Home: React.FC = () => {
  const { isAuthenticated } = useUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(normalizeNextPath(searchParams.get('next')), { replace: true });
    }
  }, [isAuthenticated, navigate, searchParams]);

  if (isAuthenticated) {
    return null;
  }

  return (
    <GuestHomePage
      onStartProspector={() =>
        navigate(`/register?next=${encodeURIComponent(buildProspectorEntryPath())}`)
      }
      onSignIn={() => navigate('/login')}
      onOpenResources={() => navigate('/resources')}
    />
  );
};
